function generateEmployeeAvatars(employees) {
    const usedInitials = new Set();
    const usedColors = new Set();

    const colors = [
        "#FF6B6B", "#6BCB77", "#4D96FF", "#FFD93D",
        "#FF6F91", "#845EC2", "#00C9A7", "#F9F871",
        "#FF9671", "#FFC75F", "#0081CF", "#008E9B"
    ];

    // Simple hash to generate consistent color per name
    const getColorForName = (name) => {
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        return colors[Math.abs(hash) % colors.length];
    };

    // Generate unique initials
    const getUniqueInitial = (name) => {
        name = name.trim();
        let initials = name[0].toUpperCase();

        if (!usedInitials.has(initials)) {
            usedInitials.add(initials);
            return initials;
        }

        // Try two-letter initials if first is taken
        const words = name.split(" ");
        if (words.length > 1) {
            initials = (words[0][0] + words[1][0]).toUpperCase();
            if (!usedInitials.has(initials)) {
                usedInitials.add(initials);
                return initials;
            }
        }

        // Try increasing substrings
        for (let i = 2; i <= name.length; i++) {
            initials = name.substring(0, i).toUpperCase();
            if (!usedInitials.has(initials)) {
                usedInitials.add(initials);
                return initials;
            }
        }

        // Fallback: add a number
        let num = 1;
        while (usedInitials.has(initials + num)) {
            num++;
        }
        usedInitials.add(initials + num);
        return initials + num;
    };

    const result = {};

    employees.forEach((emp) => {
        const fullName = emp.name || emp.user_name || emp.first_name || "U";
        const initials = getUniqueInitial(fullName);
        const color = getColorForName(fullName);

        result[emp.id] = {
        ...emp,
        initials,
        color,
        };
    });

    // Store in localStorage
    localStorage.setItem('employeeAvatars', JSON.stringify(result));

    return result;
}

export default generateEmployeeAvatars;